import { usePaginatedEndpoint } from 'hooks/usePaginatedEndpoint';
import { getConversations } from './conversation.api';
/**
 * Creates a hook to works with conversations list api TODO [TEAMS-7073]: once
 * RTK Q is ready, remove this hook, and replace usages with the hooks provided
 * by RTK Q
 *
 * Note: this is legacy code. Some params don't work as they usually work in
 * other hooks. For example instead of `limit` you should use `page_size`
 */
export const useConversations = (initialParams) => usePaginatedEndpoint({
    endpoint: getConversations,
    itemsSelector: ({ conversations }) => conversations,
    initialParams,
});
